"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const react_redux_1 = require("react-redux");
const styles_1 = require("@mui/material/styles");
const CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
const msal_react_1 = require("@azure/msal-react");
const msal_browser_1 = require("@azure/msal-browser");
const Msal_1 = require("@/Msal");
const store_1 = __importDefault(require("@/store"));
const App_1 = __importDefault(require("@/App"));
const theme_1 = __importDefault(require("@/styles/theme"));
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
        authority: process.env.REACT_APP_MSAL_AUTHORITY_URL,
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL
    }
};
const pca = new msal_browser_1.PublicClientApplication(msalConfig);
const AppWrapper = () => (react_1.default.createElement(react_redux_1.Provider, { store: store_1.default },
    react_1.default.createElement(msal_react_1.MsalProvider, { instance: pca },
        react_1.default.createElement(Msal_1.AuthProvider, null,
            react_1.default.createElement(styles_1.ThemeProvider, { theme: theme_1.default },
                react_1.default.createElement(CssBaseline_1.default, null),
                react_1.default.createElement(App_1.default, null))))));
const root = document.getElementById("root");
const container = (0, client_1.createRoot)(root);
container.render(react_1.default.createElement(AppWrapper, null));
